import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { theme, rgbaToRgb } from '../../../../theme';
const hover = `
	background: ${theme.colors.BB10T};
`;
const active = `
	color: ${theme.colors.BB100};
	background: ${theme.colors.interface.selected};

	.svg-default-state { display: none; }
	.svg-active-state { display: initial; }
	.svg-active-background { fill: ${rgbaToRgb(theme.colors.BB10T)}; }
	.svg-active-foreground { fill: ${rgbaToRgb(theme.colors.BB100)}; }
`;
export const StyledNavPanelCss = ({ highlighted }) => css `
	display: flex;
	align-items: center;
	text-decoration: none;
	background: none;
	border: none;
	border-radius: ${theme.radii.radii30};
	padding: ${theme.spacing.space20} ${theme.spacing.space30};
	cursor: pointer;
	color: ${theme.colors.BB200};
	${theme.typography.IR100}
	line-height: ${theme.spacing.space60};
	outline-offset: -1px;
	width: 100%;
	text-align: left;
	.label {
		flex-grow: 1;
	}

	svg {
		margin-right: ${theme.spacing.space20};
	}

	.svg-default-state { display: initial; }
	.svg-active-state { display: none; }
	.svg-default-foreground { fill: ${rgbaToRgb(theme.colors.BB200)}; }

	&:focus {
		background: ${theme.colors.BB20T};
		outline: 1px solid ${theme.colors.BB80};
	}

	${highlighted ? active : `&:hover {${hover}}`};
`;
export const StyledNavPanelLink = styled.a `${(c) => StyledNavPanelCss(c)}`;
export const StyledNavPanelButton = styled.button `${(c) => StyledNavPanelCss(c)}`;
//# sourceMappingURL=NavigationPanelItem.styled.js.map